import React from "react";
import { Box, Paper, Grid } from "@mui/material";
import ReviewForm from "components/ReviewForm";
import Feedback from "components/Feedback";
import GoalSetting from "components/GoalSetting";
import UserProfileCard from "components/UserProfileCard";
import Manager from "components/Manager";
import DirectReports from "components/DirectReports";

const Dashboard = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={8}>
        <Box sx={{ marginBottom: "32px", width: "100%" }}>
          <Paper
            elevation={4}
            sx={{
              minHeight: "350px",
              width: "100%",
              display: "flex",
              padding: "14px",
              borderRadius: "10px",
            }}
          >
            <ReviewForm />
          </Paper>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={7.5}>
            <Paper
              elevation={4}
              sx={{
                minHeight: "350px",
                display: "flex",
                padding: "14px",
                borderRadius: "10px",
              }}
            >
              <Feedback />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={4.5}>
            <Paper
              elevation={4}
              sx={{
                minHeight: "350px",
                display: "flex",
                cursor: "pointer",
                padding: "14px",
                borderRadius: "10px",
              }}
            >
              <GoalSetting />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={2.7}>
        <Paper
          elevation={4}
          sx={{
            minHeight: "350px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "32px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <UserProfileCard />
        </Paper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                minHeight: "60px",
                marginBottom: "6px",
                display: "flex",
                alignItems: "center",
                borderRadius: "10px",
              }}
            >
              <Manager />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                minHeight: "60px",
                display: "flex",
                alignItems: "center",
                borderRadius: "10px",
              }}
            >
              <DirectReports />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
